export default "__VITE_ASSET__BG$5htPD__"